import { render, staticRenderFns } from "./TqCard.vue?vue&type=template&id=6b7815a9&scoped=true&"
import script from "./TqCard.vue?vue&type=script&lang=js&"
export * from "./TqCard.vue?vue&type=script&lang=js&"
import style0 from "./TqCard.vue?vue&type=style&index=0&id=6b7815a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7815a9",
  null
  
)

export default component.exports